<evrideo-clipping-studio-catalog-card
  [title]="cardTitle"
  [isEditMode]="isEditMode"
  [showDeleteAction]="true"
  (cardClick)="onAdd()"
  (editClick)="onEdit()"
  (deleteClick)="onDelete()"
>
  <div
    class="text-template-card__preview-inner"
    [class.text-template-card__preview-inner--transparent]="isTransparentPreview"
    [class.text-template-card__preview-inner--checker-light]="
      isTransparentPreview && checkerboardTone === 'light'
    "
    [class.text-template-card__preview-inner--checker-dark]="
      isTransparentPreview && checkerboardTone === 'dark'
    "
    [ngStyle]="previewBackground ? { background: previewBackground } : null"
  >
    <span
      *ngIf="showBadge"
      class="text-template-card__badge"
    >{{ template.badge }}</span>

    <span
      class="text-template-card__display-text"
      [ngStyle]="{
        color: previewTextColor,
        'font-size': previewFontSize,
        'font-weight': previewFontWeight,
        'font-style': previewFontStyle,
        'text-shadow': previewTextShadow,
        'font-family': template.fontFamily || null
      }"
    >{{ cardTitle }}</span>
  </div>
</evrideo-clipping-studio-catalog-card>
